import { SettingsBase } from './SettingsBase';

export class SpeakerSettings extends SettingsBase {
    static NAME_OF_CLASS = 'SpeakerSettings';
    public SpeakerItems: SpeakerItemSettings[] = [];

    public constructor(val?: SpeakerSettings) {
        super();
        this.SpeakerItems = val?.SpeakerItems ?? [];
    }
}

export class SpeakerItemSettings {
    public CategoryID: number | null = null;

    public RaceID: number | null = null;

    /**
     * If we want to show DNX in the tables
     */
    public ShowDNX: boolean = false;

    public constructor(val?: SpeakerItemSettings) {
        this.CategoryID = val?.CategoryID ?? null;
        this.RaceID = val?.RaceID ?? null;
        this.ShowDNX = val?.ShowDNX ?? false;
    }
}
